<template>
    <div class="nb-adulte-container">
      <div :style="{ backgroundImage: 'url(' + img + ')'}" class="img-responsive">
      </div>
      <div class="d-flex vertical-center display-element prtb-60px " :style="{ backgroundImage: 'url(' + img + ')' }">
        <slot></slot>
      </div>
    </div>
  </template>
  <script>

  export default {
    props: {
      img: String,
    }
  };
  </script>
  <style scoped>
  .display-element {
    justify-content: end;
  }
  .nb-adulte-container {
    position: relative;
    background-color: white;
    display: flex;
    justify-content: space-between;
    border-bottom-right-radius: 50px;
    box-shadow: 4px 4px 24px 0px rgba(0, 0, 0, 0.15);
    margin-top:10px;
    flex-wrap:wrap;
  }
  .prtb-60px{
    padding-top:60px;
    padding-bottom:60px;
    padding-right:60px;
    box-sizing:border-box;
    background-size:auto 100%;
    background-repeat: no-repeat;
    min-height:350px;
    width:100%;
  }
  .nb-adulte-input {
    width: 75px;
    height: 35px;
    padding: 10px 20px 10px 20px;
    box-shadow: 4px 4px 24px 0px rgba(0, 0, 0, 0.15);
    border: 3px solid var(--text-color);
    font-size: 35px;
    font-family: var(--font);
    text-align: center;
  }
  
  .label-nb {
    color: var(--text-color);
    text-align: left;
    font-family: var(--font);
    font-size: 25px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  .wrap-reverse{
    flex-wrap: wrap-reverse !important;
  }
  .description-nb {
    font-family: var(--font);
    color: var(--text-color);
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 28.2px;
    /* 141% */
  }
  .img-plus-minus{
      width:60px;
    }
    .img-responsive{
      display: none;
    }
  @media screen and (max-width: 1300px) {
    .nb-adulte-img {
      min-height:250px;
  }
  .nb-adulte-input {
    width: 50px;
    height: 20px;
    font-size: 25px;
  }
  }
  @media screen and (max-width: 900px) {
    .prtb-60px{
      padding-top:20px;
      padding-bottom:20px;
      padding-right:20px;
      padding-left:20px;
      min-height: 250px;
  
    }
  }
  @media screen and (max-width: 750px) {
    .prtb-60px{
      background-image: none !important;
    }
    .display-element {
      justify-content: center;
    }
    .img-responsive{
      display: block !important;
      box-sizing:border-box;
      background-size:cover;
      background-position: bottom center;
      background-repeat: no-repeat;
      min-height:350px;
      width:100%;
    }
    .inputs-minus-plus{
      justify-content: center !important;
    }
    .labels>*{
      text-align: center;
    }
    .text-align-end{
      justify-content: center;
      text-align: center;
    }
  }
  @media screen and (max-width: 600px) {
    .nb-adulte-container {
      margin-top: 45px;
    }
    .nb-adulte-img {
      width: 100%;
    }
  
    .nb-adulte-img>img {
      width: 100%;
    }
    .label-nb {
      font-size: 18px;
    }
    .display-element {
      justify-content: center;
    }
    .p-60px{
      padding:5px;
    }
    .prtb-60px{
      background-size:100% auto;
      background-position: bottom;
    }
  }
  @media screen and (max-width: 350px) {
    .img-plus-minus{
      width:60px;
    }
  }
  </style>
  